import { useSettingsModal } from '@/context/settings-modal.context';

export type SettingsRefreshButtonsControllerBindings = {
    openSettingsModal: () => void;
};

export const useSettingsRefreshButtonsController = (): SettingsRefreshButtonsControllerBindings => {
    const { openSettingsModal } = useSettingsModal();

    return {
        openSettingsModal,
    };
};
